import React from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Grid } from 'react-md'

import { handleSubmit, InputNumber } from 'components/form'
import { PartAutoComplete } from 'components/auto-complete'
import { Modal } from 'components/core'

import { defaultValues, validationSchema } from './config'
import { handleSave } from './actions'

interface ComponentProps {
  technicalVisitId: string
  visibleModal: boolean
  disableModal: () => void
  loadParts: () => void
}

const Component: React.FC<ComponentProps> = ({ technicalVisitId, visibleModal, disableModal, loadParts }) => {
  const form = useForm({ defaultValues })

  return (
    <Modal
      title={'Inclusão de Quantidade de Peças'}
      visible={visibleModal}
      confirmTitle={'Salvar'}
      confirmDisabled={!form.formState.dirty}
      confirmAction={async () => {
        await handleSubmit(form, validationSchema, async () => {
          await handleSave({ id: technicalVisitId, ...form.getValues() })
          form.reset(defaultValues, { dirty: false })
          loadParts()
          disableModal()
        })
      }}
      closeTitle={'Fechar'}
      closeAction={async () => {
        form.reset(defaultValues, { dirty: false })
        disableModal()
      }}>
      <Grid>
        <FormContext {...form}>
          <PartAutoComplete name='part' label='Peça *' desktopSize={9} tabletSize={6} />
          <InputNumber name='quantity' label='Quantidade *' desktopSize={3} tabletSize={2} />
        </FormContext>
      </Grid>
    </Modal>
  )
}

export default Component
